import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Router } from "@angular/router";
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { AdminUser } from "../_models/adminuser"

@Injectable({ providedIn: "root" })
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<AdminUser>;
  public currentUser: Observable<AdminUser>;
  provider: "Angular";
  AppVersion: 10;

  constructor(
    private http: HttpClient,
    private router: Router) {

    this.currentUserSubject = new BehaviorSubject<AdminUser>(
      JSON.parse(localStorage.getItem("currentUser")));

    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): AdminUser {
    // this.currentUserSubject = new BehaviorSubject<any>(
    //   JSON.parse(localStorage.getItem("currentUser"))
    // );
    // this.currentUser = this.currentUserSubject.asObservable();
    return this.currentUserSubject.value;
  }

  login(username, password, provider, AppVersion) {
    localStorage.clear();
    var loginBody = {
      phoneNumber: username,
      password: password,
      provider: "Angular",
      AppVersion: 10
    };
    console.log("Login details", loginBody);
    return this.http
      .post<any>(`https://dev.cogcons.com/api/users/login`, loginBody)
      .pipe(
        map(user => {
          user.phoneNumber = loginBody.phoneNumber;
          localStorage.setItem("currentUser", JSON.stringify(user));
          this.currentUserSubject.next(user);
          return user;
        })
      );
  }

  logout() {
    localStorage.removeItem("currentUser");
    this.currentUserSubject.next(null);
    this.router.navigate(["/"]);
  }
}
